import {
    Switch, useLocation,
    // Redirect,
} from 'react-router-dom';
import AdministrationRoutes from '../routes/admin-routes';
import { adminRoutes } from '../routes/constants';
import { v4 as uuidv4 } from 'uuid';
import AdminHeader from './AdminHeader';
import { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PAlert from './PAlert';
import { setAlert } from '../../redux/actions';

const AdminMain = ({ collapsedMenu, setCollapsedMenu, toggled, setToggled, alert }) => {
    const dispatch = useDispatch();

    const handleShowAlert = () => {
        dispatch(setAlert({
            show: false,
            title: '',
            body: ''
        }));
    };

    return <main className="admin">
        <AdminHeader
            toggled={toggled}
            setToggled={setToggled}
        />
        <div className="admin__content">
            <Switch>
                {adminRoutes.map((route, index) => (
                    <AdministrationRoutes
                        key={`admin-${index}`}
                        path={route.path}
                        exact={route.exact}
                    >
                        <route.component />
                    </AdministrationRoutes>
                ))}
            </Switch>
        </div>

        <PAlert
            show={alert.show}
            setShow={handleShowAlert}
            title={alert.tile}
            body={alert.body}
            bodyStyle={alert.bodyStyle}
            footerStyle={alert.footerStyle}
            size="sm"
        />
    </main>;
};

const mapStateToProps = (state) => {
    return {
        alert: state.privaGlobal.alert
    };
};

export default connect(mapStateToProps)(AdminMain);